import Svg, { SvgProps } from './Svg';

export default function FrozenTest({
  color = 'currentColor',
  ...props
}: SvgProps) {
  return (
    <Svg viewBox="0 0 51 51" fill={color} {...props}>
      <path
        d="M36.5299 16.9163H50.2489V12.7497H40.6965L50.25 3.19701L47.3038 0.25L37.7492 9.80583V0.25H33.5826V13.9724L30.6382 16.9163H27.3327V8.58315H23.1662V16.9163H19.8606L16.9163 13.9724V0.25H12.7497V9.80583L3.19493 0.25L0.25 3.19701L9.80231 12.7497H0.25V16.9163H13.9689L16.9163 19.8642V23.1662H8.58315V27.3327H16.9163V30.6386L13.972 33.5826H0.25V37.7492H9.80542L0.25 47.3038L3.19597 50.25L12.7497 40.6969V50.2489H16.9163V36.5303L19.8637 33.5826H23.1662V41.9157H27.3327V33.5826H30.6353L33.5826 36.5303V50.2489H37.7492V40.6969L47.3019 50.25L50.2489 47.3038L40.6935 37.7492H50.2489V33.5826H36.527L33.5826 30.6386V27.3327H41.9157V23.1662H33.5826V19.8642L36.5299 16.9163ZM29.416 29.416H21.0829V21.0829H29.416V29.416Z"
        fill={color}
      />
    </Svg>
  );
}
